export default __webpack_public_path__ + "static/media/bike.4f5a1f28.svg";